uic-accordion {
  display: flex;
  flex-direction: column;
}
